/**
 * Выпадающий список по списку KLS из meta (РД: гриф, тип территории и т.п.).
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface MetaKlsOption {
  kls_id: number;
  kls_names: string;
}

export interface MetaKlsSelectProps {
  value: unknown;
  onChange: (next: number | null) => void;
  options: MetaKlsOption[];
  disabled?: boolean;
  noneLabel?: string;
  placeholder?: string;
  /** z-index для портала внутри модалок */
  contentZClass?: string;
}

export function MetaKlsSelect({
  value,
  onChange,
  options,
  disabled,
  noneLabel = "Не задан",
  placeholder = "Не задан",
  contentZClass = "z-[250]",
}: MetaKlsSelectProps) {
  const v = value != null && value !== "" ? String(value) : "none";
  return (
    <Select
      value={v}
      onValueChange={(raw) => onChange(raw === "none" ? null : Number(raw))}
      disabled={disabled}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={contentZClass}>
        <SelectItem value="none">{noneLabel}</SelectItem>
        {options.map((item) => (
          <SelectItem key={item.kls_id} value={String(item.kls_id)}>
            {item.kls_names}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
